module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkBAMAAAFkKbU9AAAAFVBMVEUAAAD///////////////////////9Iz20EAAAABnRSTlMAAQ11m8YTJGgTAAAA5ElEQVQoz7XPMU/DMBCG4acu9lwJiTlLOpeFmYnZqhTPISL+/z+BwU6blpkbrNOr83fvgRQwE5LWIDG3RyLMpDAjVIRZ0msiDWK2YEoD4gJpgiVm0mBiIV68ZBC+KRmhDii5N5Rrb4Sat2Yo2TZc8vZLyQ59+OJeb43FT+eFfXxcafC2PK40WLpaHdcedN4MxE1KKUtH600590Vx3R3UFrX4UAcfLes8O/azTrwOO2/hnWNddyyUemHcsVDqlT3byJ3dycb2pLFHwljXJ8JYn0ko9cGvJY/Pztf/cXb4enT+Oflbv9LiP6rgU8q/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/close.png
// module id = fgqV
// module chunks = 1